import { useContext } from 'react';
import { Waypoint } from 'react-waypoint';
import { StickySearchContext } from '../../Search/components/StickySearchProvider';

export default function StickyHeaderWaypoint() {
  const { handleStickyTransition } = useContext(StickySearchContext);

  return (
    <Waypoint
      topOffset={-130}
      onEnter={handleStickyTransition}
      onLeave={handleStickyTransition}
    />
  );
}
